var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDahsboardActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2589",
    "data-name": "Group 2589",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.75,
    height: 21.75,
    viewBox: "0 0 21.75 21.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 21.75,
    height: 21.75,
    fill: "#22c8bc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M.011,5.826q0-1.963,0-3.926A1.9,1.9,0,0,1,1.9,0Q5.065,0,8.227,0a1.893,1.893,0,0,1,1.9,1.891q0,3.938,0,7.876a1.894,1.894,0,0,1-1.892,1.9q-3.162,0-6.325,0a1.9,1.9,0,0,1-1.9-1.892q0-1.975,0-3.95M1.6,5.818q0,1.853,0,3.707c0,.434.127.559.566.559H7.976c.437,0,.565-.126.565-.56q0-3.682,0-7.365c0-.45-.123-.571-.578-.571H2.172c-.454,0-.576.121-.577.572q0,1.829,0,3.658",
    transform: "translate(-0.009 -0.001)",
    fill: "#22c8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M179.661,161.532q0-1.963,0-3.926a1.9,1.9,0,0,1,1.907-1.906q3.15,0,6.3,0a1.894,1.894,0,0,1,1.907,1.906q0,3.926,0,7.851a1.9,1.9,0,0,1-1.907,1.907q-3.15,0-6.3,0a1.9,1.9,0,0,1-1.907-1.907q0-1.963,0-3.926m8.53.022q0-1.865,0-3.731c0-.4-.133-.538-.538-.538q-2.931,0-5.863,0c-.416,0-.544.132-.544.556q0,3.694,0,7.389c0,.42.13.551.55.551q2.919,0,5.839,0c.432,0,.556-.128.557-.568q0-1.829,0-3.658",
    transform: "translate(-168.027 -145.617)",
    fill: "#22c8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M184.7,8.565c-1.05,0-2.1,0-3.15,0a1.9,1.9,0,0,1-1.9-1.888q0-2.4,0-4.8A1.894,1.894,0,0,1,181.538,0q3.174,0,6.349,0a1.893,1.893,0,0,1,1.877,1.887q0,2.4,0,4.8a1.9,1.9,0,0,1-1.888,1.877c-1.058,0-2.116,0-3.174,0m.031-6.979q-1.478,0-2.955,0c-.408,0-.541.132-.542.534q0,2.156,0,4.312c0,.418.131.548.552.548h5.838c.422,0,.554-.13.554-.546q0-2.144,0-4.288c0-.434-.127-.56-.565-.56h-2.883",
    transform: "translate(-168.016 0)",
    fill: "#22c8bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M5.058,203.607c1.058,0,2.116,0,3.174,0a1.894,1.894,0,0,1,1.883,1.882q0,2.4,0,4.8a1.894,1.894,0,0,1-1.882,1.883q-3.174,0-6.349,0A1.894,1.894,0,0,1,0,210.288q0-2.4,0-4.8a1.9,1.9,0,0,1,1.882-1.882c1.058,0,2.116,0,3.174,0m-.018,6.979q1.478,0,2.955,0c.4,0,.535-.135.535-.54q0-2.156,0-4.312c0-.406-.133-.541-.535-.541q-2.931,0-5.862,0c-.419,0-.547.13-.548.553q0,2.144,0,4.288c0,.422.13.553.547.553q1.453,0,2.907,0",
    transform: "translate(0 -190.423)",
    fill: "#22c8bc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDahsboardActive);
export default __webpack_public_path__ + "static/media/icon_dahsboard_active.9ae2e2673fc01cabe086df7f8927b8a1.svg";
export { ForwardRef as ReactComponent };